import React from 'react'
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import { useLocation } from 'react-router-dom';
import { AccordionSummary, IconButton, AccordionDetails, Typography, Stack, Link, Grid2, TextField, Autocomplete, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, List, ListItem, ListItemText, Box, Divider, Button, InputLabel, Select, MenuItem, SelectChangeEvent } from '@mui/material'
import CustomAccordion from '../../components/Accordian/accordian';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useState, useEffect, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import dayjs, { Dayjs } from 'dayjs';
import { usePostReservationMutation, useLazyGetOccupancyDataQuery, useGetOperatorGuidesQuery, useGetSimilarUnitsQuery } from '../../api/endpoints/apiConfig';
import { AircallNofity } from '../../components/Common/notify';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { OccupancyData } from '../../models/OccupancyData';
import CircularProgress from '@mui/material/CircularProgress';
import { toast } from "react-toastify";
import { addId } from '../../store/reducers/aircallTagSlice';
import { useAppDispatch } from '../../hooks/useAppDispatch';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { timezoneMapping } from '../../components/Dashboard/timezoneUtils';

type Props = {}
interface FormState {
    comments: string;
    selectedType: string;
    email: string;
    lastname: string;
    phNum: string;
    firstname: string;
    selectedMoveDate: Dayjs | null;
    selectedFollowDate: Dayjs | null;
    occupancyid: number;
    facility_id: number;
    external_id: string;
}

const phoneDigitsOnly = (value: string): string => value.replace(/\D/g, '');

/** Formats up to 10 digits as (xxx) yyy-zzzz while typing */
const formatPhoneInputValue = (raw: string): string => {
    const d = phoneDigitsOnly(raw).slice(0, 10);
    if (d.length === 0) return '';
    if (d.length <= 3) return `(${d}`;
    if (d.length <= 6) return `(${d.slice(0, 3)}) ${d.slice(3)}`;
    return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
};

// Extend dayjs with plugins
dayjs.extend(utc);
dayjs.extend(timezone);

const CreateReservation = (props: Props) => {

    const navigate = useNavigate();
    const location = useLocation();
    const operatorsData = sessionStorage.getItem('operators');
    const FacilityData = sessionStorage.getItem('facilityData');
    const facilityDataObject = FacilityData ? JSON.parse(FacilityData) : null;
    const facilityscript = facilityDataObject[0]?.guides?.[0]?.create_reservation_script;
    const isTestFacility = facilityDataObject[0]?.is_test;
    const operators = operatorsData ? JSON.parse(operatorsData) : [];
    const { data } = location.state || {};
    const operatorId = sessionStorage.getItem('operatorId');
    const { data: FacilityOperatorAlerts } = useGetOperatorGuidesQuery(operatorId ? parseInt(operatorId) : 0);
    const OperatorAlert = FacilityOperatorAlerts?.guides || [];
    const [selectedUnit, setSelectedUnit] = useState(data?.external_unit_id ?? null);


    const handleUnitChange = (

        event: React.SyntheticEvent,
        value: { external_id: string; unit_number: string } | null
    ) => {
        setSelectedUnit(value ? value.external_id : null);
    };

    const removeHtmlTags = (text: string | null | undefined): string => {
        if (!text) {
            return ''; // Return an empty string for null or undefined input
        }
        // Decode HTML entities and normalize spaces
        const textArea = document.createElement('textarea');
        textArea.innerHTML = text;
        const decodedText = textArea.value.replace(/\s+/g, ' ').trim();

        return decodedText;
    };

    const formatUnitFeatures = (unit: {
        floor?: number;
        inside?: number;
        drive_up?: number;
        climate?: number;
        air_cooled?: number;
        heated?: number;
        elevator?: number;
        stair_access?: number;
    } | null | undefined): string => {
        if (!unit) return '';
        const features: string[] = [];
        if (unit.floor === 1) features.push('First Floor');
        if (unit.floor !== undefined && unit.floor > 1) features.push('Upper');
        if (unit.inside === 1) features.push('Inside');
        if (unit.drive_up === 1) features.push('Drive Up');
        if (unit.climate === 1) features.push('Climate');
        if (unit.air_cooled === 1) features.push('Air Cooled');
        if (unit.heated === 1) features.push('Heated');
        if (unit.elevator === 1) features.push('Elevator Access');
        if (unit.stair_access === 1) features.push('Stair Access');
        return features.join(', ') || 'No unit details available';
    };
    const script = facilityscript ? facilityscript : operators.operators[0]?.call_script;
    const storedTimezone = sessionStorage.getItem('timezoneName') || 'UTC';
    const validTimezone = timezoneMapping[storedTimezone] || storedTimezone;
    // Calculate the current date/time in the specified timezone
    const minDate: Dayjs = dayjs().tz(validTimezone);
    console.log('Min Date (based on timezone):', minDate.format());
    // const minDate = dayjs(); // Current date
    const [Islookup, setIslookup] = useState(false);
    const firstNameInputRef = useRef<HTMLInputElement>(null);
    // Hook to dispatch actions
    const dispatch = useAppDispatch();
    const [searchdata, setSearchdata] = useState({
        firstnamesearch: '',
        lastnamesearch: '',
        accesscodesearch: '',
        emailsearch: '',
        phonesearch: '',
    });
    const [gridData, setGridData] = useState<OccupancyData[]>([]);
    const [isgrid, setIsgrid] = useState(false);
    const FacilityId = data?.facility_id;
    const ExternalUnitId = data?.external_type_id;
    const { data: similarUnits, isLoading: unitLoading } = useGetSimilarUnitsQuery(
        { FacilityId, ExternalUnitId },
        { skip: !FacilityId || !ExternalUnitId || (data?.units?.length ?? 0) > 0 }
    );
    console.log('External', ExternalUnitId)
    // Grid Loaded based on the search value
    const [trigger, { data: occupancyData, isFetching }] = useLazyGetOccupancyDataQuery();
    const handleLookupTenantSearch = async () => {
        if (searchdata.emailsearch.length < 1 && searchdata.firstnamesearch.length < 1 && searchdata.lastnamesearch.length < 1 && searchdata.accesscodesearch.length < 1 && searchdata.phonesearch.length < 1) {
            setIsgrid(false)
            AircallNofity({ type: 'error', Msg: 'Please enter atleast one search criteria' });
        }
        else {
            setIsgrid(true)
            try {
                await trigger({
                    facilityid: data?.facility_id,
                    email: searchdata.emailsearch.toLowerCase(),
                    firstname: searchdata.firstnamesearch.toLowerCase(),
                    lastname: searchdata.lastnamesearch.toLowerCase(),
                    accesscode: searchdata.accesscodesearch,
                    phone: searchdata.phonesearch
                });
            } catch (err) {
                console.error('Error fetching occupancy data:', err);
            }
        }
    };
    useEffect(() => {
        if (occupancyData) {
            setGridData(occupancyData);
        }
    }, [occupancyData]);
    // Setting Data Read from the session storage
    const SettingData = sessionStorage.getItem('setting');
    const Settings = SettingData ? JSON.parse(SettingData) : [];
    const IsLead = Settings.is_deal_type_lead_enabled;
    const maxdate = Settings.deal_lead_time_days ? Settings.deal_lead_time_days : 2;
    const [errors, setErrors] = useState({
        firstname: false,
        lastname: false,
        phNum: false,
        email: false,
    });
    // control properities
    const [formData, setFormData] = useState<FormState>({
        comments: '',
        selectedType: 'reservation',
        email: '',
        lastname: '',
        phNum: '',
        firstname: '',
        selectedMoveDate: dayjs(),
        selectedFollowDate: dayjs().add(1, 'day'),
        occupancyid: 0,
        facility_id: 0,
        external_id: '',

    });
    // Email validate and onchange function
    const validateEmail = (email: string): boolean => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };
    // email handleBlur
    const handleBlur = () => {
        if (!validateEmail(formData.email)) {
            setErrors({
                ...errors,
                email: true,
            });
        } else {
            setErrors({
                ...errors,
                email: false,
            });
        }
    };
    const handlePhoneBlur = () => {
        const d = phoneDigitsOnly(formData.phNum);
        setErrors((prev) => ({
            ...prev,
            phNum: d.length !== 10,
        }));
    };
    //Search Handle change
    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setSearchdata({
            ...searchdata,
            [name]: value,
        });
    }
    // text box onchange events and validation
    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        if (name === 'firstname' || name === 'lastname') {
            if (value === null || value.trim() === "") {
                setErrors({
                    ...errors,
                    [name]: true,
                });
                setFormData({
                    ...formData,
                    [name]: value,
                });
                return;
            }
            else {
                setErrors({
                    ...errors,
                    [name]: false,
                });

                setFormData({
                    ...formData,
                    [name]: value,
                });
            }
        }
        else if (name === 'phNum') {
            const formattedValue = formatPhoneInputValue(value);
            setFormData({
                ...formData,
                [name]: formattedValue,
            });
            const d = phoneDigitsOnly(formattedValue);
            if (d.length === 10) {
                setErrors((prev) => ({ ...prev, phNum: false }));
            }
        }
        else {
            setFormData({
                ...formData,
                [name]: value,
            });
        }
    };
    const [calendarRestrictions, setCalendarRestrictions] = useState({
        followMinDate: dayjs().add(1, 'day'), // Default to tomorrow
        followMaxDate: dayjs().add(1, 'day'), // Default to tomorrow
    });
    const handleDateChange = (newValue: Dayjs | null, field: 'selectedMoveDate' | 'selectedFollowDate') => {
        setFormData((prevData) => {
            if (field === 'selectedMoveDate') {
                const moveInDate = newValue;
                let followUpDate = dayjs().add(1, 'day'); // Default to tomorrow
                let followMinDate = dayjs().add(1, 'day'); // Default to tomorrow
                let followMaxDate = dayjs().add(1, 'day'); // Default to tomorrow

                if (moveInDate) {
                    if (moveInDate.isSame(dayjs(), 'day') || moveInDate.isSame(dayjs().add(1, 'day'), 'day')) {
                        // Move-in date is today or tomorrow
                        followUpDate = dayjs().add(1, 'day'); // Tomorrow
                    } else {
                        // Move-in date is more than 2 days into the future
                        followUpDate = moveInDate.subtract(1, 'day'); // 1 day before move-in
                        followMaxDate = moveInDate.subtract(1, 'day'); // 1 day before move-in
                    }
                }

                setCalendarRestrictions({
                    followMinDate,
                    followMaxDate,
                });

                return {
                    ...prevData,
                    selectedMoveDate: moveInDate,
                    selectedFollowDate: followUpDate,
                };
            } else {
                // Updating the selectedFollowDate
                return {
                    ...prevData,
                    selectedFollowDate: newValue,
                };
            }
        });
    };

    function getRandomThreeDigitNumber() {
        return Math.floor(Math.random() * 900) + 100;
    }
    const TestLoadData = () => {
        const randomThreeDigitNumber = getRandomThreeDigitNumber();
        setFormData((prevData) => ({
            ...prevData,
            firstname: `John${randomThreeDigitNumber}`, // Use template literal for string concatenation
            lastname: `Doe${randomThreeDigitNumber}`,
            phNum: formatPhoneInputValue(`${randomThreeDigitNumber}4567890`),
            email: `johndoe${randomThreeDigitNumber}@example.com`,
            selectedMoveDate: dayjs(),
            selectedFollowDate: dayjs().add(1, 'day'),
            comments: "Test"
        }));
        toast.success("Test Data is loaded");
    };
    // Logic for the onClick event
    const handleLookupTenant = (): void => {
        setIslookup(true);
        setFormData((prevData) => ({
            ...prevData,
            firstname: '',
            lastname: '',
            phNum: '',
            email: '',

        }));
        requestAnimationFrame(() => {
            const element = document.getElementById('occupant-info');
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
                if (firstNameInputRef.current) {
                    firstNameInputRef.current.focus();
                }
            }
        });
    };
    const CustomNoResultsOverlay = () => (
        <Box textAlign="center" p={2}>
            <Typography variant="h6">No Data Available</Typography>
        </Box>
    );
    const formatPhoneNumber = (phone: string | number | null | undefined): string => {
        if (phone === null || phone === undefined) return 'N/A';
        const d = phoneDigitsOnly(String(phone));
        if (d.length === 0) return 'N/A';
        if (d.length < 10) return 'Invalid Number';
        return formatPhoneInputValue(d);
    };
    const SetOccupancyData = (params: any) => {
        const data = params.row;
        setFormData((prevData) => ({
            ...prevData,
            firstname: data?.first_name,
            lastname: data?.last_name,
            phNum: formatPhoneInputValue(String(data?.phone_number ?? '')),
            email: data?.email,
            occupancyid: data?.id,
            facility_id: data?.facility_id,
            external_id: (data?.external_id).toString(),
        }));
        setIslookup(false);
        setIsgrid(false);
        setSearchdata({
            ...searchdata,
            firstnamesearch: '',
            lastnamesearch: '',
            accesscodesearch: '',
            emailsearch: '',
            phonesearch: ''
        });
    };
    // columns def
    const colDefs: GridColDef[] = [
        { field: 'first_name', headerName: 'First Name', minWidth: 120 },
        { field: 'last_name', headerName: 'Last Name', minWidth: 120 },
        { field: 'address', headerName: 'Address', minWidth: 150 },
        { field: 'access_code', headerName: 'Access Code', minWidth: 115, filterable: false, sortable: false },
        {
            field: "phone_number",
            headerName: "Phone",
            minWidth: 130,

            headerAlign: 'center', align: 'center',
            flex: 1,
            valueGetter: (params) => {
                const phone = params; // Accessing the phone directly
                return phone ? formatPhoneNumber(phone) : 'N/A'; // Assuming formatPhoneNumber is a valid function
            },
        },
        { field: 'email', headerName: 'Email', minWidth: 210 },
        {
            field: 'action',
            headerName: 'Action',
            flex: 1,
            width: 50,
            filterable: false,
            sortable: false,
            renderCell: (params) => (
                <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                    <Button size="small" variant="contained" onClick={() => SetOccupancyData(params)}>select</Button>
                </div>
            ),
        },
    ];
    const tagdatasave = () => {
        // Retrieve and parse tag data from sessionStorage
        const tagdata = sessionStorage.getItem('tagsdata');
        const tagdataObject = tagdata ? JSON.parse(tagdata) : {};
        const tags = tagdataObject.tags || [];
        const Reservationdetails = tags.find((tag: { name: string }) => tag.name === 'Reservation - New');
        const IsLeaddata = tags.find((tag: { name: string }) => tag.name === 'Lead - New');
        // API call if tags are found
        if (Reservationdetails) {
            dispatch(addId(Reservationdetails.id)); // Dispatch to Redux store
        }
        if (IsLead) {
            dispatch(addId(IsLeaddata.id)); // Dispatch to Redux store
        }
    };

    // save reservation function
    const [postReservation, { isLoading: isSaving }] = usePostReservationMutation();
    const saveReservation = async () => {
        const facilityId = data?.facility_id;
        let savesuccess = true;
        const phoneSubmit = phoneDigitsOnly(formData.phNum);
        var agentName = sessionStorage.getItem('FirstName') + ' ' + sessionStorage.getItem('LastName');
        const reservationData = {
            first_name: formData.firstname,
            last_name: formData.lastname,
            email: formData.email,
            phone: phoneSubmit,
            quoted_rate: parseInt(data?.price.replace('$', '')) || 0,
            type: formData.selectedType,
            status: "pending",
            move_in_date: formData.selectedMoveDate ? formData.selectedMoveDate.format('YYYY-MM-DD') : '',
            followup_date: formData.selectedFollowDate ? formData.selectedFollowDate.format('YYYY-MM-DD') : '',
            external_unit_id: selectedUnit,
            //external_promotion_id: data?.external_promotion_id,
            //external_promotion_id: data?.external_promotion_id && data.external_promotion_id !== "0" ? data.external_promotion_id : null,
            external_product_type_id: data?.external_type_id,
            note: formData.comments,
            agent: agentName,

            ...(data?.external_promotion_id && data.external_promotion_id !== "0" && { external_promotion_id: data.external_promotion_id }),
            ...(formData.external_id !== '' && { external_occupant_id: formData.external_id })
        };
        if (facilityId === 0 || facilityId === undefined) {
            AircallNofity({ type: 'error', Msg: 'Facility ID is undefined or invalid' });
            savesuccess = false;
        }
        else if (!formData.firstname || formData.firstname === '') {
            setErrors({
                ...errors,
                firstname: true,
            });
            savesuccess = false;
        }
        else if (!formData.lastname || formData.lastname === '') {
            setErrors({
                ...errors,
                lastname: true,
            });
            savesuccess = false;
        }
        else if (!formData.email || formData.email === '') {
            setErrors({
                ...errors,
                email: true,
            });
            savesuccess = false;
        }
        else if (phoneSubmit.length !== 10) {
            setErrors((prev) => ({
                ...prev,
                phNum: true,
            }));
            savesuccess = false;
        }
        else if (formData.selectedMoveDate === null || formData.selectedMoveDate === undefined) {
            AircallNofity({ type: 'error', Msg: 'Move-in Date is required' });
            savesuccess = false;
        }
        else if (formData.selectedFollowDate === null || formData.selectedFollowDate === undefined) {
            AircallNofity({ type: 'error', Msg: 'Follow-up Date is required' });
            savesuccess = false;
        }
        // else if (formData.selectedMoveDate && formData.selectedFollowDate && formData.selectedMoveDate.isAfter(formData.selectedFollowDate)) {
        //     AircallNofity({ type: 'error', Msg: 'Follow-up Date cannot be earlier than Move-in Date' });
        //     savesuccess = false;
        // }
        else if (formData.selectedType === '') {
            AircallNofity({ type: 'error', Msg: 'Type is required' });
            savesuccess = false;
        }
        else if (data?.price === null) {
            AircallNofity({ type: 'error', Msg: 'Price is required' });
            savesuccess = false;
        }
        else if (data?.external_unit_id === null) {
            AircallNofity({ type: 'error', Msg: 'Unit ID is required' });
            savesuccess = false;
        }
        else if (data?.external_promotion_id === null) {
            AircallNofity({ type: 'error', Msg: 'Promotion ID is required' });
            savesuccess = false;
        }
        else if (data?.external_type_id === null) {
            AircallNofity({ type: 'error', Msg: 'Type ID is required' });
            savesuccess = false;
        }
        try {
            if (savesuccess) {
                const result = await postReservation({ reservationData, facilityId }).unwrap();
                if (result.deal.external_id) {
                    tagdatasave();
                    const setdata = {
                        Dealid: result.deal.external_id,
                        FacilityId: facilityId,
                        width: data?.width,
                        length: data?.length,
                        price: data?.price,
                        features: formatUnitFeatures(data),
                        price_formatted: data.price_formatted,
                        promotion: data?.promotion,
                        external_promotion_id: data?.external_promotion_id,
                        promotions: data?.promotions ?? [],
                    }

                    navigate('/ReservationConfirmation', { state: { setdata } });
                }
                else {
                    AircallNofity({ type: 'error', Msg: 'Failed to save reservation' });
                }
            }
        } catch (error) {
            console.error('Failed to save reservation:', error);
            AircallNofity({ type: 'error', Msg: 'Failed to save reservation' });
        }
    };
    const isNonProduction = window.config.appEnv !== 'production' ? true : false;
    const selectedPrice = data?.price;
    const numericPrice = selectedPrice ? parseFloat(selectedPrice.replace(/[$,]/g, "")) : 0;

    // Use units array from unit-type-price-list (Storage360) when available; otherwise fall back to similar-units API (SiteLink)
    const unitOptions: { external_id: string; unit_number: string }[] = !data
        ? []
        : (data.units?.length ?? 0) > 0
          ? data.units.map((u: { id: number; unit_number: string }) => ({
                external_id: u.id.toString(),
                unit_number: u.unit_number,
            }))
          : (similarUnits?.filter(
                (unit: { width?: number; length?: number; price?: number }) =>
                    unit.width === data.width &&
                    unit.length === data.length &&
                    parseFloat(String(unit.price)) === numericPrice
            ) ?? []).map((u: { external_id: string; unit_number: string }) => ({
                external_id: u.external_id,
                unit_number: u.unit_number,
            }));
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
        }, 1000);
    }, [unitOptions]);
    return (
        <>
            {isSaving ? (
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "80vh"
                    }}
                >
                    <CircularProgress /> {/* Spinner appears while saving */}
                </div>
            ) : (
                <>
                    <Stack direction='row' spacing={1} alignItems={'center'} my={3}>
                        <IconButton >
                            <ArrowBackRoundedIcon
                                sx={{ color: 'text.secondary' }}
                                onClick={() => navigate(`/Dashboard/${data?.facility_id}`)} />
                        </IconButton>
                        <Typography variant='h3' color='text.secondary'>Back to facility page</Typography>
                    </Stack>
                    <Box my={2}>
                        <CustomAccordion defaultExpanded>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1-content"
                                id="panel1-header"
                            >
                                <Typography variant="h3" color="text.secondary">Call Script
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography
                                    color="text.primary"
                                    textAlign={'left'}
                                    dangerouslySetInnerHTML={{ __html: removeHtmlTags(script || OperatorAlert[0]?.create_reservation_script || '') }}
                                />
                            </AccordionDetails>
                        </CustomAccordion>
                    </Box>
                    <Box my={2}>
                        <CustomAccordion defaultExpanded>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1-content"
                                id="panel1-header"
                            >
                                <Typography variant="h3" color="text.secondary">
                                    Create Reservation
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Grid2 container spacing={2} columns={12} >

                                    <Grid2 size={{ xs: 12, md: 4 }}>
                                        <Stack mb={2} direction='row' spacing={2} justifyContent={'space-between'} alignItems={'center'} useFlexGap>
                                            <Typography variant='h3' color='text.secondary'>Occupant</Typography>
                                            <Link sx={{ color: '#2400cb', fontWeight: 500, cursor: 'pointer', fontStyle: 'italic' }} onClick={() => handleLookupTenant()}>Lookup Occupant</Link>
                                        </Stack>
                                        <Grid2 container spacing={2} columns={12}>
                                            <Grid2 size={{ xs: 12, md: 12 }}>
                                                <TextField
                                                    id="First-name"
                                                    name="firstname"
                                                    label="First Name"
                                                    variant="outlined"
                                                    size="small"
                                                    value={formData.firstname}
                                                    onChange={handleChange}
                                                    error={errors.firstname}
                                                    helperText={errors.firstname ? "Invalid First name field" : ""}
                                                    sx={{ width: '290px' }}
                                                />
                                            </Grid2>
                                            <Grid2 size={{ xs: 12, md: 12 }}>
                                                <TextField
                                                    id="Last-name"
                                                    name="lastname"
                                                    label="Last Name"
                                                    variant="outlined"
                                                    size="small"
                                                    value={formData.lastname}
                                                    onChange={handleChange}
                                                    error={errors.lastname}
                                                    helperText={errors.lastname ? "Invalid Last name field" : ""}
                                                    sx={{ width: '290px' }}
                                                />

                                            </Grid2>
                                            <Grid2 size={{ xs: 12, md: 12 }}>
                                                <TextField
                                                    id="Phone-number"
                                                    name="phNum"
                                                    label="Phone Number"
                                                    variant="outlined"
                                                    size="small"
                                                    value={formData.phNum}
                                                    onChange={handleChange}
                                                    onBlur={handlePhoneBlur}
                                                    error={errors.phNum}
                                                    helperText={errors.phNum ? "Enter a valid 10-digit phone number" : ""}
                                                    inputProps={{ maxLength: 14, inputMode: 'numeric' }}
                                                    sx={{ width: '290px' }}
                                                />
                                            </Grid2>
                                            <Grid2 size={{ xs: 12, md: 12 }}>
                                                <TextField
                                                    id="email"
                                                    name="email"
                                                    label="Email"
                                                    variant="outlined"
                                                    size="small"
                                                    value={formData.email}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    error={errors.email}
                                                    helperText={errors.email ? "Invalid email address" : ""}
                                                    sx={{ width: '290px' }}
                                                />
                                            </Grid2>
                                        </Grid2>
                                    </Grid2>
                                    {/* Vertical Divider */}
                                    <Divider orientation="vertical" flexItem />
                                    <Grid2 size={{ xs: 12, md: 4 }}>
                                        <Typography mb={2} variant='h3' color='text.secondary'>Reservation Option </Typography>
                                        <Box mb={2}>
                                            <FormControl>
                                                <FormLabel id="type" sx={{ color: 'text.secondary', fontWeight: 500 }}>Type</FormLabel>
                                                <RadioGroup
                                                    row
                                                    aria-labelledby="type"
                                                    name="selectedType"
                                                    value={formData.selectedType}
                                                    onChange={handleChange}
                                                >
                                                    <FormControlLabel
                                                        value="reservation"
                                                        control={<Radio />}
                                                        label="Reservation"
                                                    />
                                                    {IsLead ? (
                                                        <FormControlLabel
                                                            value="deal"
                                                            control={<Radio />}
                                                            label="Lead"
                                                        />
                                                    ) : null}

                                                </RadioGroup>
                                            </FormControl>
                                        </Box>
                                        <Grid2 container spacing={2} columns={12}>
                                            <Grid2 size={6}>
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <DatePicker
                                                        label="Move-In Date"
                                                        value={formData.selectedMoveDate}
                                                        onChange={(newValue) => handleDateChange(newValue, 'selectedMoveDate')}
                                                        minDate={dayjs()} // Allow only today or future dates
                                                        maxDate={dayjs().add(maxdate, 'day')} // Adjust based on business rules
                                                        slotProps={{
                                                            textField: { size: 'small' },
                                                        }}
                                                    />
                                                </LocalizationProvider>
                                            </Grid2>
                                            <Grid2 size={6}>
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <DatePicker
                                                        label="Follow-Up Date"
                                                        value={formData.selectedFollowDate}
                                                        onChange={(newValue) => handleDateChange(newValue, 'selectedFollowDate')}
                                                        minDate={calendarRestrictions.followMinDate}
                                                        maxDate={calendarRestrictions.followMaxDate}
                                                        slotProps={{
                                                            textField: { size: 'small' },
                                                        }}
                                                    />
                                                </LocalizationProvider>
                                            </Grid2>

                                        </Grid2>
                                    </Grid2>
                                    {/* Vertical Divider */}
                                    <Divider orientation="vertical" flexItem />
                                    <Grid2 size={{ xs: 12, md: 3 }}>
                                        <Typography mb={2} variant='h3' color='text.secondary'>Unit Information </Typography>
                                        <List>
                                            {/* Row 1: Product Type (left), Unit Number (right) */}
                                            <ListItem sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                <ListItemText primary="Product Type" secondary={data?.type_name || data?.productType || '—'} />
                                                <Autocomplete
                                                    disablePortal
                                                    options={unitOptions}
                                                    getOptionLabel={(option) => option.unit_number ? option.unit_number.toString() : "No Unit"}
                                                    value={selectedUnit ? unitOptions.find(item => item.external_id === selectedUnit) ?? null : null}
                                                    onChange={handleUnitChange}
                                                    loading={unitLoading}
                                                    sx={{ width: 165 }}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Unit Number"
                                                            size="small"
                                                            InputProps={{
                                                                ...params.InputProps,
                                                                endAdornment: (
                                                                    <>
                                                                        {unitLoading ? <CircularProgress color="inherit" size={20} /> : null}
                                                                        {params.InputProps.endAdornment}
                                                                    </>
                                                                ),
                                                            }}
                                                        />
                                                    )}
                                                />
                                            </ListItem>
                                            {/* Row 2: Unit Size (left), Promotion (right) */}
                                            <ListItem sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                <ListItemText primary="Unit Size" secondary={`${data.width > 0 ? data.width + "' x " + data.length + "'" : data.length + "'"}`} />
                                                <ListItemText primary="Promotion" secondary={data.promotion} sx={{ textAlign: 'right' }} />
                                            </ListItem>

                                            {/* Monthly Rate */}
                                            <ListItem>
                                                <ListItemText primary="Monthly Rate" secondary={data.price} />
                                            </ListItem>

                                            {/* Features */}
                                            <ListItem>
                                                <ListItemText
                                                    primary="Features"
                                                    secondary={formatUnitFeatures(data)}
                                                />
                                            </ListItem>
                                        </List>
                                    </Grid2>
                                </Grid2>
                                <Box mb={2}>
                                    <Typography mb={2} variant='h3' color='text.secondary'>Reservation Note</Typography>
                                    <textarea
                                        placeholder='Type a quick note here..'
                                        style={{ padding: '16px', minWidth: '100%', width: '100%', maxWidth: '100%', minHeight: '80px', maxHeight: '120px', borderColor: 'rgba(0, 0, 0, 0.23)', fontFamily: "'poppins', sans-serif", fontSize: 14, }}
                                        id="comments"
                                        name="comments"
                                        rows={4}
                                        cols={50}
                                        value={formData.comments}
                                        onChange={handleChange}
                                    />
                                </Box>
                                <Box my={3} textAlign={'end'}>
                                    {(isNonProduction || isTestFacility !== 0) && (
                                        <Link
                                            sx={{ color: '#2400cb', cursor: 'pointer', ml: 4, fontStyle: 'italic' }} // Increased margin-left to 4
                                            onClick={() => TestLoadData()}
                                        >
                                            Load Test Data
                                        </Link>
                                    )}
                                    <Button
                                        variant='contained'
                                        size='large'
                                        sx={{ ml: 4 }}  // Add margin-left to the Button as well for more space
                                        onClick={saveReservation}
                                    >
                                        CREATE RESERVATION
                                    </Button>
                                </Box>
                            </AccordionDetails>
                        </CustomAccordion>
                        {Islookup ? (<CustomAccordion defaultExpanded>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1-content"
                                id="panel1-header"
                            >
                                <div id="occupant-info">
                                    <Typography variant="h3" color="text.secondary">Search Occupant
                                    </Typography>
                                </div>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Box py={2} style={{ width: '100%', height: '100px' }}>
                                    <Grid2 size={{ xs: 12, md: 12 }}>
                                        <TextField
                                            id="First-namesearch"
                                            name="firstnamesearch"
                                            label="First Name"
                                            variant="outlined"
                                            size="small"
                                            value={searchdata.firstnamesearch}
                                            onChange={handleSearchChange}
                                            onKeyDown={(e) => e.key === 'Enter' && handleLookupTenantSearch()}
                                            sx={{ width: '250px', marginRight: '10px', marginBottom: '16px' }}
                                            inputRef={firstNameInputRef}
                                        />
                                        <TextField
                                            id="last-namesearch"
                                            name="lastnamesearch"
                                            label="Last Name"
                                            variant="outlined"
                                            size="small"
                                            value={searchdata.lastnamesearch}
                                            onChange={handleSearchChange}
                                            onKeyDown={(e) => e.key === 'Enter' && handleLookupTenantSearch()}
                                            sx={{ width: '250px', marginRight: '10px', marginBottom: '16px' }}
                                        />
                                        <TextField
                                            id="email-search"
                                            name="emailsearch"
                                            label="Email"
                                            variant="outlined"
                                            size="small"
                                            value={searchdata.emailsearch}
                                            onChange={handleSearchChange}
                                            onKeyDown={(e) => e.key === 'Enter' && handleLookupTenantSearch()}
                                            sx={{ width: '350px', marginRight: '10px', marginBottom: '16px' }}
                                        />
                                    </Grid2>
                                    <Grid2 size={{ xs: 12, md: 12 }}>
                                        <TextField
                                            id="accesscode-search"
                                            name="accesscodesearch"
                                            label="Access Code"
                                            variant="outlined"
                                            size="small"
                                            value={searchdata.accesscodesearch}
                                            onChange={handleSearchChange}
                                            onKeyDown={(e) => e.key === 'Enter' && handleLookupTenantSearch()}
                                            sx={{ width: '250px', marginRight: '10px', marginBottom: '16px' }}
                                        />
                                        <TextField
                                            id="phone-search"
                                            name="phonesearch"
                                            label="Phone"
                                            variant="outlined"
                                            size="small"
                                            value={searchdata.phonesearch}
                                            onChange={handleSearchChange}
                                            onKeyDown={(e) => e.key === 'Enter' && handleLookupTenantSearch()}
                                            sx={{ width: '250px', marginRight: '10px', marginBottom: '16px' }}
                                        />
                                        <Button
                                            variant='contained'
                                            size='large'
                                            sx={{ ml: 2 }}
                                            onClick={handleLookupTenantSearch}
                                        >
                                            Search
                                        </Button>
                                    </Grid2>
                                </Box>
                                <Box sx={{ height: '30px' }} />
                                {isgrid && (
                                    <>
                                        <Typography variant="h3" color="text.secondary">
                                            Pick an Occupant
                                        </Typography>
                                        <Box py={2} sx={{ width: '100%' }}>
                                            {isFetching ? (
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                        height: "70vh",
                                                    }}
                                                >
                                                    <CircularProgress />
                                                </Box>
                                            ) : (
                                                <DataGrid
                                                    rows={gridData}
                                                    columns={colDefs}
                                                    disableColumnMenu
                                                    slots={{
                                                        noResultsOverlay: CustomNoResultsOverlay,
                                                    }}
                                                    hideFooterPagination  // This will hide the pagination footer
                                                    autoHeight  // This will adjust the grid height to fit all rows, removing the need for scrolling
                                                />
                                            )}
                                        </Box>
                                    </>
                                )}
                            </AccordionDetails>
                        </CustomAccordion>) : null}
                    </Box>
                </>
            )
            }
        </>
    )
}

export default CreateReservation
